import { Helmet } from "react-helmet-async";
import { ToolTabsViewOnly } from "./ToolTabsViewOnly";
import { useToolDataContext } from "./ToolDataProvider";

export const PageToolViewOnly = () => {
  const { tool } = useToolDataContext();
  return (
    <>
      <Helmet>
        <title>{`${tool.name}`}</title>
      </Helmet>
      <ToolTabsViewOnly />
    </>
  );
};
